<template>
  <div>
    <br>
    <br>
    <br>
    <br>
    <h1 class="text-center">404 Page not founds.</h1>
  </div>
</template>
<script>
export default {

  name: 'error-404',

  data() {
    return {

    }
  },
  metaInfo() {
    return {
      title: '404',
    }
  },
}

</script>
